// services/org.js
import apiClient from './api';

/**
 * Fetches all organizations for the logged-in user's tenant.
 * Corresponds to: GET /api/org/
 */
export async function userOrgs() {
  const response = await apiClient.get('/org/');
  return response.data; // The interceptor handles errors
}

/**
 * Creates or updates an organization's details.
 * Corresponds to: POST /api/org/
 * @param {object} orgData - The full organization data object.
 */
export async function saveOrgDetails(orgData) {
  const response = await apiClient.post('/org/', { orgData });
  return response.data;
}

/**
 * Fetches the configuration for the logged-in user's tenant.
 * Corresponds to: GET /api/org/config
 */
export async function getConfig() {
  const response = await apiClient.get('/org/config');
  return response.data;
}

/**
 * Creates or updates the configuration for the logged-in user's tenant.
 * Corresponds to: PUT /api/org/config
 * @param {object} configData - The configuration data object.
 */
export async function saveConfigDetails(configData) {
  const response = await apiClient.put('/org/config', { configData });
  return response.data;
}

/**
 * Deletes a specific organization.
 * Corresponds to: DELETE /api/org/:orgId
 * @param {string} orgId - The ID of the organization to delete.
 */
export async function deleteOrg(orgId) {
  const response = await apiClient.delete(`/org/${orgId}`);
  return response.data;
}

// Note: The old getSalesforceData function was likely part of the OAuth flow.
// The new OAuth routes on the backend handle this differently.
// If you need a direct SF data call, a new service and route should be created.
